// userSlice.ts or userActions.ts
import { createAsyncThunk } from "@reduxjs/toolkit";
import { CollectionSite, SendRequestCallback, TrapType } from "../../types";
import { showError } from "../notifications";

export const fetchCollectionSites = createAsyncThunk<
  { data: CollectionSite[]; count: number },
  SendRequestCallback<
    any,
    { data: { data: CollectionSite[]; count: number } },
    any
  >
>("devices/fetchCollectionSites", async (sendRequest, { dispatch }) => {
  try {
    const response = await sendRequest("get")({
      url: `/org/collectionSites`,
    });

    return response.data;
  } catch (err) {
    // dispatch(showError("Failed to fetch Collection Sites"));
    console.log(err);
    return [];
  }
});

interface UpdateCollectionSite {
  sendRequest: SendRequestCallback<any, any, any>;
  collectionSite: CollectionSite;
}

export const updateCollectionSite = createAsyncThunk(
  "collectionSites/updateCollectionSite",
  async (
    { sendRequest, collectionSite }: UpdateCollectionSite,
    { dispatch }
  ) => {
    try {
      await sendRequest("patch")({
        url: `/collectionSite/${collectionSite.id}`,
        data: collectionSite,
      });
      return collectionSite;
    } catch (err) {
      dispatch(showError("Failed to update Collection Sites"));
      console.log(err);
    }
  }
);

interface CreateCollectionSite {
  sendRequest: SendRequestCallback<any, any, any>;
  collectionSite: CollectionSite;
}

export const createCollectionSite = createAsyncThunk(
  "collectionSites/createCollectionSite",
  async (
    { sendRequest, collectionSite }: CreateCollectionSite,
    { dispatch }
  ) => {
    try {
      const response: any = await sendRequest("post")({
        url: `/collectionSite`,
        data: Object.fromEntries(
          Object.entries(collectionSite).filter(([_, value]) => value !== "")
        ),
      });
      return response.data;
    } catch (err) {
      dispatch(showError("Failed to create Collection Sites"));
      console.log(err);
    }
  }
);

export const fetchTrapTypes = createAsyncThunk<
  { data: TrapType[]; count: number },
  SendRequestCallback<any, { data: { data: TrapType[]; count: number } }, any>
>("devices/fetchTrapTypes", async (sendRequest, { dispatch }) => {
  try {
    const response = await sendRequest("get")({
      url: `/org/trapTypes`,
    });
    return response.data;
  } catch (err) {
    // dispatch(showError("Failed to find Collection Methods"));
    console.log(err);
    return [];
  }
});

interface UpdateCollectionType {
  sendRequest: SendRequestCallback<any, any, any>;
  trapType: TrapType;
}

export const updateTrapType = createAsyncThunk(
  "trapType/updateTrapType",
  async ({ sendRequest, trapType }: UpdateCollectionType, { dispatch }) => {
    try {
      await sendRequest("patch")({
        url: `/trapType/${trapType.id}`,
        data: trapType,
      });
      return trapType;
    } catch (err) {
      dispatch(showError("Failed to update Collection Sites"));
      console.log(err);
    }
  }
);

interface CreateCollectionType {
  sendRequest: SendRequestCallback<any, any, TrapType>;
  trapType: TrapType;
}

export const createTrapType = createAsyncThunk(
  "trapType/createTrapType",
  async ({ sendRequest, trapType }: CreateCollectionType, { dispatch }) => {
    try {
      const response = await sendRequest("post")({
        url: `/trapType`,
        data: trapType,
      });
      return response.data;
    } catch (err) {
      dispatch(showError("Failed to create Collection Method"));
      console.log(err);
    }
  }
);
